<div class="toggle-buttons">
  <button type="button" (click)="firstButton()" class="first-button btn"
    [ngClass]="{'btn-primary': firstButtonSelected, 'btn-secondary-clear': !firstButtonSelected}">{{toggleButton1Name}}</button>
  <button type="button" class="second-button btn" (click)="secondButton()"
    [ngClass]="{'btn-primary': !firstButtonSelected, 'btn-secondary-clear': firstButtonSelected}">{{toggleButton2Name}}</button>
</div>
